import { defineComponent as _defineComponent } from 'vue'
import { Event } from '@/models/Event';
import { Location } from '@/models/Location';
import { formRules } from '@/helpers/tools';
import LocationSelectField from '@/components/location/SelectField.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationSelection',
  props: {
    record: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {





function onEventLocationSelect(locRec: Location | null) {
    if (locRec) {
        emit('input', locRec.id);
    } else {
        emit('input', null);
    }
}

return { __sfc: true,emit, onEventLocationSelect, formRules, LocationSelectField }
}

})